var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgFacebookCircle = function SvgFacebookCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 41 41",
    width: 42,
    height: 42
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.5 41A20.5 20.5 0 1141 20.5 20.53 20.53 0 0120.5 41zm0-40A19.5 19.5 0 1040 20.5 19.53 19.53 0 0020.5 1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.16 17.45H18v-1.8a4.82 4.82 0 01.6-2.79 3.31 3.31 0 012.89-1.36 11.84 11.84 0 013.33.33l-.46 2.76a6.45 6.45 0 00-1.5-.22c-.72 0-1.37.26-1.37 1v2.1h3l-.21 2.7H21.5v9.33H18v-9.35h-1.84v-2.7"
  })));
};
export default SvgFacebookCircle;